module.exports = __webpack_public_path__ + "static/media/lt.c3aeac0d.svg";